import { local_user_task_update_without_generatons } from '@/state/generation/user_task/entity/init_local_user_task_update_without_generations';
import { store } from '@/state/store';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { FN_GRID2D__init_possible_features } from '../../_methods/FN_GRID2D__init_possible_features';

export function HANDLER_CLIENT__user_task_upsert_without_generations(items: any) {
  assert_array_instanceof(items, DTO__user_task);

  FN_GRID2D__init_possible_features(items);

  store.dispatch(local_user_task_update_without_generatons(items));
}
